import React, { useState, useEffect } from "react";
import styled from "styled-components";
import moment from "moment";
import { apiClient } from "../../App";
import Spinner from "../../components/Spinner";

interface Props {
  history: History;
}

const StyledPushLogs = styled.div`
  margin: 1rem auto;
  height: 100vh;
  overflow-y: scroll;

  .loading {
    text-align: center;
  }

  .log-row td { 
    padding: 0.75rem 0.25rem;
    border-bottom: 1px solid ${props => props.theme.colors.gray2};
  }

  .log-row td.date {
    width: 10%;
  }

  .log-row td.message {
    width: 20%;
  }

  .log-row td.time {
    width: 5%;
  }
`;

const PushLogs: React.FC<Props> = props => {
  const [loading, setLoading] = useState(true);
  const [logs, setLogs] = useState<any[]>([]);

  const loadLogs = async () => {
    const { data: { logs } } = await apiClient.get<any>("/push-log");

    setLogs(logs);
    setLoading(false);
  }

  useEffect(() => {
    loadLogs();
  }, []);

  function emailRow(emails: Array<String>) {
    if (emails.length === 0)
      return "";

    // TODO: Need to implement expand row
    // if (emails.length > 5)
    //     return `${emails.slice(0, 5).join(", ")} ... more (${emails.length - 5})`;

    return emails.join(", ");
  }

  return (
    <StyledPushLogs>
      {loading && <div className="loading"><Spinner />Retrieving push logs...</div>}
      {!loading && <h2>{logs.length} push logs</h2>}

      <table>
        <tbody>
          {logs.map((log: any) => (
            <tr className="log-row" key={log.created}> {/*TODO: Need id for list*/}
              <td className="date">{moment(log.created).format("YYYY-MM-DD HH:ss")}</td>
              <td className="message">{log.body}</td>
              <td className="time">{log.ms} ms</td>
              <td>{emailRow(log.to)}</td>
              <td>{emailRow(log.failedSendingTo)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </StyledPushLogs>
  );
};

export default PushLogs;
